module.exports = __webpack_public_path__ + "img/staticLogo.0dfbe9c0.png";